export enum AttachmentErrors {
  None = "",
  InvalidExtension = "Invalid file type. Please select a file type from the custom list in the file picker.",
  InvalidFile = "No file. Please provide a file."
}

export class AttachmentUtil {
  public getValidatedFileExtensions = (fileNames: FileList, allowedFileTypes: string): boolean => {
    let isValidExtension = true;

    for (let i = 0; i < fileNames.length && isValidExtension; ++i) {
      const attachment = fileNames.item(i);
      isValidExtension = !!attachment && this.isValidFileExtension(attachment.name, allowedFileTypes);
    }
    return isValidExtension;
  };

  public getValidatedFileSize = (files: FileList): boolean => {
    let isValidFileSize = true;
    for (let i = 0; i < files.length; ++i) {
      const attachment = files.item(i);
      if (attachment !== null && attachment.size === 0) {
        alert("Empty(0 KB) file " + attachment.name + " cannot be attached. Please select file/s again");
        isValidFileSize = false;
      }
    }
    return isValidFileSize;
  };

  public isValidFileExtension = (fileName: string, allowedFileTypes: string): boolean => {
    const allowedFiles = allowedFileTypes.replace(/[. ]/g, "").replace(" ", "").toLowerCase().split(",");

    if (!fileName) {
      return false;
    }

    const [, ext = ""] = fileName.match(/\.([^\.]+)$/) || [];

    const isValidExtension = allowedFiles.includes(ext.toLowerCase());
    if (!isValidExtension) {
      alert("File extension '" + ext + "' is not allowed. Please choose from allowed file types " + allowedFileTypes);
      return false;
    }
    return true;
  };

  public convertFileSizeToKb(fileSize: string): string {
    const fileSizeKb: number = parseFloat(fileSize) / 1024;
    if (fileSizeKb === 0) return "0";
    else if (fileSizeKb < 1) return "1";
    else return fileSizeKb.toFixed(0).toString();
  }

  public getIconForAttachmentStatusGrid(isVolatile: boolean): string {
    if (isVolatile) {
      return "Delete";
    } else {
      return "";
    }
  }
}

export const attachmentUtil = new AttachmentUtil();
